import SelectionDesignItem from '../selection/design_item_base';

export default class extends SelectionDesignItem {}
